module.exports = __webpack_public_path__ + "static/media/closeAddOptions.42610caf.svg";